export default "__VITE_ASSET__70D0kZyO__"